export var ENTITY = "broker";
export var REDUCER_KEY = "BROKER_V2";
export var BASE_PATH_ENTITY = "brokers";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
